
    <span class="adstxt-status-icon" [matTooltip]="AdsTxtStatusLabels[status]">
      <i class="fas fa-check text-success" *ngIf="status!==AdsTxtStatus.NOT_EXIST"></i>
      <i class="fas fa-times text-danger" *ngIf="status==AdsTxtStatus.NOT_EXIST"></i>
    </span>
  